import React from 'react';
import { store } from '../index';
import { APP_TYPE, ZENPAY, SCHEDULER } from '../constants/AppConstants';
/*
HELPER UTILITY FUNCTIONS THAT CAN BE REUSED SHOULD BE REFACTORED HERE
*/

/* MONEY RECEIVE AN INTEGER (xxxyy) AN RETURN A STRING WITH MONEY FORMAT ($xxx.yy)*/
export const money = (value) => {
  value = Number(value);
  if (value > 0) {
    return "$" + ((value / 100).toFixed(2))
  } else {
    return "---"
  };
}

/* URL SETUP */
export const apiUrl = () => {
  let urlParamsHost = store.getState().urlParamsReducer.host;
  let source = store.getState().urlParamsReducer.source;
  let hostName;
  if (APP_TYPE === ZENPAY && window.location.hostname != "localhost") {
    hostName = window.location.hostname.replace('zenpay', 'api-checkout');
  } else if (APP_TYPE === SCHEDULER && source !== 'pa' && window.location.hostname != "localhost" && urlParamsHost !== '') {
    // hostName = window.location.hostname.replace('zenpay', 'api-checkout');
    hostName = urlParamsHost;
  } else if (APP_TYPE === SCHEDULER && source === 'pa') {
    hostName = 'zenpay-supermarche-pa.zenhq.io';
  } else {
    hostName = "api-checkout-staging.zenhq.io";
  }

  return window.location.protocol + '//' + hostName + '/api/v1/'
}

/*zenManage URL */

export const zenManageUrl = () => {
  let hostName;
  const thisDomain = window.location.hostname;
  if (!["localhost", "staging-zenmanage.zenhq.io", "zenpay-staging.zenhq.io"].includes(thisDomain)) {
    hostName = thisDomain.replace('-zenmanage', '');
  } else {
    hostName = "staging.zenhq.io"
  }
  return window.location.protocol + '//' + hostName + '/api/v1/'
}

/* HEADER SETUP */
export const headerHelper = (token) => {
  let headers = new Headers();
  headers.append('Content-Type', 'application/json');
  headers.append('Authorization', `Token token=${token}`);
  return headers;
}

/* LOADER */
export const getLoader = () => {
  return (
    <img src={require('../gifAssets/loader-2.gif')} style={{ width: '50px', height: '50px' }} alt='loader' />
  );
}

/* ADDRESS UPDATE REPORT */
export const getAddressReport = (cart) => {
  return {
    shipping_address: {
      first_name: cart.shipping_address.first_name,
      last_name: cart.shipping_address.last_name,
      phone: cart.shipping_address.phone,
      company: cart.shipping_address.company,
      note: cart.shipping_address.note,
      address1: cart.shipping_address.address1,
      address2: cart.shipping_address.address2,
      city: cart.shipping_address.city,
      country: cart.shipping_address.country,
      country_code: cart.shipping_address.country_code,
      province: cart.shipping_address.province,
      province_code: cart.shipping_address.province_code,
      zip: cart.shipping_address.zip,
    }
  }
}

/* CUSTOMER CREATE/UPDATE REPORT */
export const getCustomerReport = (customer) => {
  return {
    customer: {
      accepts_marketing: customer.accepts_marketing,
      email: customer.email,
      save_information: customer.save_information,
    }
  }
}

/* INIT GUEST USER CART SHIPPING ADDRESS */
export const initShippingAddress = () => {
  return {
    first_name: '',
    last_name: '',
    phone: '',
    company: '',
    note: '',
    address1: '',
    address2: '',
    city: '',
    country: '',
    country_code: '',
    province: '',
    province_code: '',
    zip: '',
  }
}

export const initGuest = () => {
  return {
    accepts_marketing: false,
    email: '',
    first_name: '',
    last_name: '',
    is_registered: false,
    last_name: '',
    name: '',
    save_information: false,
  }
}

// GETS CARD LOGO 

export const getCardLogo = (brand) => {
  var image = '';
  switch (brand) {
    case 'visa':
      image = require('../imageAssets/visa.svg');
      return image;
      break;
    case 'mastercard':
      image = require('../imageAssets/mastercard.svg');
      break;
      return image;
    case 'paypal':
      image = require('../imageAssets/paypal.svg');
      return image;
      break;
    case 'interac':
      image = require('../imageAssets/interac.svg');
      return image;
      break;
    default:
      return image;
      break;
  }
}

// COMPARE DELIVERY SELECTION DATE

export const isDeliverySelectionValid = (selectedDateStr) => {
  let today = new Date();
  let currDate = today.getDate();
  let currMonth = today.getMonth() + 1;
  let currYear = today.getFullYear();
  let selectedDateSplit = selectedDateStr.split('-');

  var selectionValid = true;

  if (selectedDateSplit[0] < currYear) {
    selectionValid = false;
  } else if (selectedDateSplit[1] < currMonth) {
    selectionValid = false;
  } else if (selectedDateSplit[2] < currDate) {
    selectionValid = false;
  }

  return selectionValid;
}

export const hexToRgbA = (hex, opacity) => {
  var c;
  if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
      c= hex.substring(1).split('');
      if(c.length== 3){
          c= [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c= '0x'+c.join('');
      return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+`,${opacity})`;
  }
  throw new Error('Bad Hex');
}
